import React, { Component } from 'react';

import Container from 'components/container';
import ForgotPasswordForm from './ForgotPasswordForm';
import OnboardingStore from 'modules/onboarding/OnboardingStore';

import './ForgotPasswordPage.scss';

class ForgotPasswordPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount = () => {
        OnboardingStore.on('change', this.onStateChange);
    };

    componentWillUnmount = () => {
        OnboardingStore.removeListener('change', this.onStateChange);
    };

    onStateChange = (loading, sent) => {
        this.setState({ loading: loading, sent: sent });
    };

    render() {
        return (
            <div className="login-page page">
                <Container transparent fluid>
                    <div className="login-form-wrapper">
                        <ForgotPasswordForm
                            loading={this.state.loading}
                            sent={this.state.sent}
                        />
                    </div>
                </Container>
            </div>
        );
    }
}

export default ForgotPasswordPage;



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/forgot-password/ForgotPasswordPage.jsx